import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  labelClassName?: string;
}
export function Input({
  label,
  error,
  className = '',
  labelClassName = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full mb-4" data-id="element-13">
      <label htmlFor={inputId} className={`block text-sm font-semibold mb-1.5 ${labelClassName || 'text-zinc-300'}`} data-id="element-14">
        {label}
        {props.required && <span className="text-amber-500 ml-0.5" aria-hidden="true" data-id="element-15">
            *
          </span>}
      </label>
      <input id={inputId} className={`w-full px-4 py-3 bg-zinc-800 border ${error ? 'border-red-500' : 'border-zinc-700'} rounded-lg text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-colors ${className}`} aria-invalid={error ? 'true' : undefined} aria-describedby={error ? `${inputId}-error` : undefined} {...props} data-id="element-16" />
      {error && <p id={`${inputId}-error`} className="mt-1.5 text-sm text-red-400 font-medium" role="alert" data-id="element-17">
          {error}
        </p>}
    </div>;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: {
    value: string;
    label: string;
  }[];
  error?: string;
  labelClassName?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  labelClassName = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full mb-4" data-id="element-18">
      <label htmlFor={selectId} className={`block text-sm font-semibold mb-1.5 ${labelClassName || 'text-zinc-300'}`} data-id="element-19">
        {label}
        {props.required && <span className="text-amber-500 ml-0.5" aria-hidden="true" data-id="element-20">
            *
          </span>}
      </label>
      <select id={selectId} className={`w-full px-4 py-3 bg-zinc-800 border ${error ? 'border-red-500' : 'border-zinc-700'} rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-colors appearance-none ${className}`} aria-invalid={error ? 'true' : undefined} aria-describedby={error ? `${selectId}-error` : undefined} {...props} data-id="element-21">
        <option value="" disabled data-id="element-22">
          Select an option
        </option>
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-23">
            {opt.label}
          </option>)}
      </select>
      {error && <p id={`${selectId}-error`} className="mt-1.5 text-sm text-red-400 font-medium" role="alert" data-id="element-24">
          {error}
        </p>}
    </div>;
}